import type { CampaignStatus, CommLogStatus, DealStatus } from './types';

export interface CommStatusMeta {
  label: string;
  bg: string;
  text: string;
  darkBg: string;
  darkText: string;
  pulse?: boolean;
}

const LOG_STATUS_META: Record<CommLogStatus, CommStatusMeta> = {
  QUEUED: {
    label: 'Queued',
    bg: 'bg-brand-100', text: 'text-brand-700',
    darkBg: 'dark:bg-brand-900/30', darkText: 'dark:text-brand-300',
    pulse: true,
  },
  SENT: {
    label: 'Sent',
    bg: 'bg-amber-100', text: 'text-amber-700',
    darkBg: 'dark:bg-amber-900/30', darkText: 'dark:text-amber-300',
  },
  DELIVERED: {
    label: 'Delivered',
    bg: 'bg-success-100', text: 'text-success-700',
    darkBg: 'dark:bg-success-900/30', darkText: 'dark:text-success-300',
  },
  READ: {
    label: 'Read',
    bg: 'bg-teal-100', text: 'text-teal-700',
    darkBg: 'dark:bg-teal-900/30', darkText: 'dark:text-teal-300',
  },
  FAILED: {
    label: 'Failed',
    bg: 'bg-danger-100', text: 'text-danger-700',
    darkBg: 'dark:bg-danger-900/30', darkText: 'dark:text-danger-300',
  },
  CLICKED: {
    label: 'Clicked',
    bg: 'bg-violet-100', text: 'text-violet-700',
    darkBg: 'dark:bg-violet-900/30', darkText: 'dark:text-violet-300',
  },
};

const CAMPAIGN_STATUS_META: Record<CampaignStatus, CommStatusMeta> = {
  DRAFT: {
    label: 'Draft',
    bg: 'bg-neutral-100', text: 'text-neutral-600',
    darkBg: 'dark:bg-neutral-700/60', darkText: 'dark:text-neutral-300',
  },
  SCHEDULED: {
    label: 'Scheduled',
    bg: 'bg-brand-100', text: 'text-brand-700',
    darkBg: 'dark:bg-brand-900/30', darkText: 'dark:text-brand-300',
  },
  QUEUED: {
    label: 'Queued',
    bg: 'bg-indigo-100', text: 'text-indigo-700',
    darkBg: 'dark:bg-indigo-900/30', darkText: 'dark:text-indigo-300',
    pulse: true,
  },
  SENDING: {
    label: 'Sending',
    bg: 'bg-amber-100', text: 'text-amber-700',
    darkBg: 'dark:bg-amber-900/30', darkText: 'dark:text-amber-300',
    pulse: true,
  },
  COMPLETED: {
    label: 'Completed',
    bg: 'bg-success-100', text: 'text-success-700',
    darkBg: 'dark:bg-success-900/30', darkText: 'dark:text-success-300',
  },
  PARTIAL: {
    label: 'Partly sent',
    bg: 'bg-warning-100', text: 'text-warning-700',
    darkBg: 'dark:bg-warning-900/30', darkText: 'dark:text-warning-300',
  },
  FAILED: {
    label: 'Failed',
    bg: 'bg-danger-100', text: 'text-danger-700',
    darkBg: 'dark:bg-danger-900/30', darkText: 'dark:text-danger-300',
  },
};

export function logStatusMeta(status: CommLogStatus | DealStatus | string): CommStatusMeta {
  return LOG_STATUS_META[status as CommLogStatus] ?? {
    label: status.charAt(0) + status.slice(1).toLowerCase(),
    bg: 'bg-neutral-100', text: 'text-neutral-600',
    darkBg: 'dark:bg-neutral-700/60', darkText: 'dark:text-neutral-300',
  };
}

export function campaignStatusMeta(status: CampaignStatus): CommStatusMeta {
  return CAMPAIGN_STATUS_META[status] ?? CAMPAIGN_STATUS_META.DRAFT;
}
